import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStatePush = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 128 128"
    data-test="push-empty-state"
    {...props}
  >
    <path
      d="M13.4727 61.452C13.4727 75.031 18.8669 88.054 28.4688 97.6558C38.0707 107.258 51.0936 112.652 64.6727 112.652C78.2517 112.652 91.2747 107.258 100.877 97.6558C110.478 88.054 115.873 75.031 115.873 61.452C115.873 47.8729 110.478 34.8499 100.877 25.2481C91.2747 15.6462 78.2517 10.252 64.6727 10.252C51.0936 10.252 38.0707 15.6462 28.4688 25.2481C18.8669 34.8499 13.4727 47.8729 13.4727 61.452Z"
      fill={colors.grey5}
    />
    <path
      d="M41.5156 102.231C41.5156 102.877 43.9552 103.496 48.2976 103.953C52.64 104.409 58.5296 104.666 64.6707 104.666C70.8119 104.666 76.7015 104.409 81.0439 103.953C85.3863 103.496 87.8259 102.877 87.8259 102.231C87.8259 101.586 85.3863 100.967 81.0439 100.51C76.7015 100.053 70.8119 99.7969 64.6707 99.7969C58.5296 99.7969 52.64 100.053 48.2976 100.51C43.9552 100.967 41.5156 101.586 41.5156 102.231Z"
      fill={colors.grey15}
    />
    <path
      d="M87.1414 94.2644C87.1414 95.9241 86.4821 97.5157 85.3086 98.6893C84.135 99.8629 82.5433 100.522 80.8837 100.522H48.4531C46.7934 100.522 45.2017 99.8629 44.0282 98.6893C42.8546 97.5157 42.1953 95.9241 42.1953 94.2644V24.7109C42.1953 23.0512 42.8546 21.4595 44.0282 20.286C45.2017 19.1124 46.7934 18.4531 48.4531 18.4531H80.8867C82.5464 18.4531 84.1381 19.1124 85.3117 20.286C86.4852 21.4595 87.1445 23.0512 87.1445 24.7109L87.1414 94.2644Z"
      fill="white"
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.7148 24.3165L73.4618 24.3154"
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.8548 23.3379C56.6072 23.354 56.3751 23.4636 56.2054 23.6446C56.0358 23.8256 55.9414 24.0644 55.9414 24.3125C55.9414 24.5605 56.0358 24.7993 56.2054 24.9803C56.3751 25.1613 56.6072 25.271 56.8548 25.287C57.1023 25.271 57.3344 25.1613 57.5041 24.9803C57.6737 24.7993 57.7681 24.5605 57.7681 24.3125C57.7681 24.0644 57.6737 23.8256 57.5041 23.6446C57.3344 23.4636 57.1023 23.354 56.8548 23.3379Z"
      fill={colors.purple100}
    />
    <path
      d="M61.25 94.1721C61.25 95.079 61.6102 95.9487 62.2515 96.5899C62.8927 97.2311 63.7624 97.5913 64.6692 97.5913C65.576 97.5913 66.4457 97.2311 67.0869 96.5899C67.7282 95.9487 68.0884 95.079 68.0884 94.1721C68.0884 93.2653 67.7282 92.3956 67.0869 91.7544C66.4457 91.1132 65.576 90.7529 64.6692 90.7529C63.7624 90.7529 62.8927 91.1132 62.2515 91.7544C61.6102 92.3956 61.25 93.2653 61.25 94.1721V94.1721Z"
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.1055 30.1777H83.2315V87.821H46.1055V30.1777Z"
      fill={colors.cyan10}
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.1055 30.1777H64.1133V87.821H46.1055V30.1777Z"
      fill="white"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.3867 39.625H79.9147V52.9044H49.3867V39.625Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1133 39.625H79.915V52.9044H64.1133V39.625Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1133 48.75H76.2783"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1133 43.7793H76.2783"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.3867 56.252H79.9147V62.7229H49.3867V56.252Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1133 56.252H79.915V62.7229H64.1133V56.252Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.6537 97.4845C63.8729 97.4885 63.1129 97.2326 62.4935 96.7572C61.8741 96.2818 61.4304 95.6139 61.2323 94.8586C61.0342 94.1033 61.0929 93.3036 61.3993 92.5854C61.7056 91.8672 62.2421 91.2713 62.9243 90.8914V18.7193C62.2452 18.3369 61.7119 17.7404 61.4079 17.0229C61.1038 16.3053 61.046 15.5073 61.2436 14.7534C61.4413 13.9996 61.8831 13.3325 62.5001 12.8564C63.117 12.3803 63.8744 12.1221 64.6537 12.1221C65.433 12.1221 66.1903 12.3803 66.8073 12.8564C67.4243 13.3325 67.8661 13.9996 68.0637 14.7534C68.2614 15.5073 68.2036 16.3053 67.8995 17.0229C67.5955 17.7404 67.0622 18.3369 66.3831 18.7193V90.8914C67.0653 91.2713 67.6018 91.8672 67.9081 92.5854C68.2144 93.3036 68.2732 94.1033 68.0751 94.8586C67.8769 95.6139 67.4333 96.2818 66.8138 96.7572C66.1944 97.2326 65.4345 97.4885 64.6537 97.4845Z"
      fill="white"
    />
    <path
      d="M64.6538 12.7789C65.3238 12.7724 65.9749 13.0008 66.4941 13.4245C67.0132 13.8481 67.3676 14.4402 67.4956 15.0979C67.6237 15.7555 67.5174 16.4373 67.1951 17.0248C66.8729 17.6123 66.355 18.0683 65.7316 18.3137V91.2952C66.3498 91.5453 66.8617 92.0027 67.1797 92.5888C67.4977 93.175 67.6019 93.8535 67.4745 94.5081C67.3471 95.1627 66.996 95.7526 66.4814 96.1767C65.9668 96.6008 65.3207 96.8327 64.6538 96.8327C63.9869 96.8327 63.3408 96.6008 62.8262 96.1767C62.3116 95.7526 61.9605 95.1627 61.8331 94.5081C61.7057 93.8535 61.8099 93.175 62.1279 92.5888C62.4459 92.0027 62.9578 91.5453 63.576 91.2952V18.3137C62.9525 18.0683 62.4347 17.6123 62.1124 17.0248C61.7902 16.4373 61.6839 15.7555 61.8119 15.0979C61.94 14.4402 62.2944 13.8481 62.8135 13.4245C63.3327 13.0008 63.9838 12.7724 64.6538 12.7789ZM64.6538 11.4756C63.7622 11.4717 62.8928 11.7535 62.1732 12.2799C61.4536 12.8062 60.9216 13.5493 60.6553 14.4002C60.3889 15.2511 60.4023 16.1649 60.6934 17.0076C60.9845 17.8503 61.538 18.5776 62.2728 19.0826V90.5276C61.5417 91.0349 60.9917 91.7623 60.7029 92.604C60.4142 93.4457 60.4018 94.3576 60.6675 95.2068C60.9333 96.0561 61.4633 96.7982 62.1803 97.3252C62.8974 97.8521 63.7639 98.1363 64.6538 98.1363C65.5436 98.1363 66.4102 97.8521 67.1272 97.3252C67.8443 96.7982 68.3743 96.0561 68.64 95.2068C68.9058 94.3576 68.8934 93.4457 68.6047 92.604C68.3159 91.7623 67.7659 91.0349 67.0348 90.5276V19.0826C67.7695 18.5776 68.3231 17.8503 68.6142 17.0076C68.9053 16.1649 68.9186 15.2511 68.6523 14.4002C68.386 13.5493 67.854 12.8062 67.1344 12.2799C66.4147 11.7535 65.5454 11.4717 64.6538 11.4756Z"
      fill={colors.purple100}
    />
  </SvgIcon>
);
